import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export function useFacebookPageView() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && (window as any).fbq) {
      (window as any).fbq("track", "PageView");
    }
  }, [location.pathname]);
}